import { render, staticRenderFns } from "./OdList.vue?vue&type=template&id=75e9810c&scoped=true"
import script from "./OdList.vue?vue&type=script&lang=js"
export * from "./OdList.vue?vue&type=script&lang=js"
import style0 from "./OdList.vue?vue&type=style&index=0&id=75e9810c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e9810c",
  null
  
)

export default component.exports